/**
 * @const props - Page section props
 * @property {undefined|boolean} contained - wether the section has a inner div that has a max width
 * @property {number|undefined} maxWidth - max width of the inner section
 */
const props = {
  /** wether the section has a inner div that has a max width */
  contained: Boolean,
  /** max width of the inner section */
  maxWidth: Number,
};

export default props;
